//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "HomeSlider",
  data() {
    return {
      slide: 1
    };
  },
  props: {
    elements: Array
  },
  methods: {
    goTo(genere) {
      this.$router.push({ name: "singleGenres", params: { type: genere } });
    }
  }
};
